export enum MessageDialogueActions {
    close = 1,
    toSafety = 2,
    newApplication = 4,
}
